import Badge from "../components/common/Badge";

export const switchTransactionStatusType = (status: string) => {
  switch (status) {
    case 'pending':
      return <Badge badgeStyle="pill" type="default" text="Pending" />;
    case 'initiated':
      return <Badge badgeStyle="pill" type="default" text="Initiated" />;
    case 'completed':
      return <Badge badgeStyle="pill" type="success" text="Complete" />;
    case 'error':
      return <Badge badgeStyle="pill" type="danger" text="Error" />;
    default:
      return "N/A";
  }
};